import { i18n } from '~/utils';

export const BLOCKER_KINDS = [
  'companies',
  'contact_persons',
  'contracts',
  'customer_connections',
  'delivery_notes',
  'document_processing',
  'integrations',
  'invoices',
  'master_data',
  'prices_and_articles',
  'related_companies',
  'same_company_in_target',
  'sites_and_cost_centers',
  'users',
] as const;

export const DATA_EXCHANGE_STATUS = [
  'confirmed',
  'implementation_supplier',
  'implementation_vestigas',
  'in_qualification',
  'interested',
  'live',
  'no_status',
  'not_feasible',
  'on_hold_supplier',
  'qr_code',
  'test_data_exchanged',
  'test_phase',
] as const;

export const DATA_EXCHANGE_STATUS_I18N_MAP = () => ({
  confirmed: i18n.t(($) => $.status.confirmed, { ns: 'dataExchange' }),
  implementation_supplier: i18n.t(($) => $.status.implementationSupplier, {
    ns: 'dataExchange',
  }),
  implementation_vestigas: i18n.t(($) => $.status.implementationVestigas, {
    ns: 'dataExchange',
  }),
  in_qualification: i18n.t(($) => $.status.inQualification, {
    ns: 'dataExchange',
  }),
  interested: i18n.t(($) => $.status.interested, { ns: 'dataExchange' }),
  live: i18n.t(($) => $.status.live, { ns: 'dataExchange' }),
  no_status: i18n.t(($) => $.status.noStatus, { ns: 'dataExchange' }),
  not_feasible: i18n.t(($) => $.status.notFeasible, { ns: 'dataExchange' }),
  on_hold_supplier: i18n.t(($) => $.status.onHoldSupplier, {
    ns: 'dataExchange',
  }),
  qr_code: i18n.t(($) => $.status.qrCode, { ns: 'dataExchange' }),
  test_data_exchanged: i18n.t(($) => $.status.testDataExchanged, {
    ns: 'dataExchange',
  }),
  test_phase: i18n.t(($) => $.status.testPhase, { ns: 'dataExchange' }),
});

// Literal-union type of all allowed status values
export type DataExchangeStatus = (typeof DATA_EXCHANGE_STATUS)[number];
